import React from 'react';

import SelectionModal from './abstract/modal';

function renderProjects(project) {
  return <strong>{project.displayName || project.name}</strong>;
}

const ProjectsSelectionModal = props => (
  <SelectionModal
    itemLabel="projects"
    queryKey="name_or_research_property_name_or_research_property_address_cont"
    renderItem={renderProjects}
    searchPath="/projects.json"
    searchPlaceholder="Search Projects"
    {...props}
  />
);

export default ProjectsSelectionModal;
